import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createOrderPaymentApi,
  verifyOrderPaymentApi,
} from "@/redux/api/order-processing-api/razorpay-api";
import { CreateOrderRazApi, getOrdersApi, getSingleOrdersApi, PlaceOrderApi } from "@/redux/api/order-processing-api/ordersApi";

// Async thunks for API calls
export const CreateOrderRaz = createAsyncThunk(
  "order/CreateOrderRaz",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await CreateOrderRazApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const RazorPayOrderCreate = createAsyncThunk(
  "order/RazorPayOrderCreate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createOrderPaymentApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const RazorPayVerifyOrderPayment = createAsyncThunk(
  "order/RazorPayVerifyOrderPayment",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await verifyOrderPaymentApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const PlaceOrder = createAsyncThunk(
  "order/PlaceOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PlaceOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const getOrders = createAsyncThunk(
  "order/getOrders",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getOrdersApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const getSingleOrders = createAsyncThunk(
  "order/getSingleOrders",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getSingleOrdersApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

// Initial state

const initialState = {
  loading: false,
  orders: {},
  singleOrders: {},
  createOrderResponse: {},
  createOrderRazResponse: {},
  orderProcessing: false,
};

// Slice definition
const OrderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CreateOrderRaz.pending, (state) => {
        state.loading = true;
        state.createOrderResponse = {};
      })
      .addCase(CreateOrderRaz.fulfilled, (state, action) => {
        state.loading = false;
        state.createOrderResponse = action.payload.response;
      })
      .addCase(CreateOrderRaz.rejected, (state) => {
        state.loading = false;
        state.createOrderResponse = {};
      });

    builder
      .addCase(RazorPayOrderCreate.pending, (state) => {
        state.loading = true;
        state.createOrderRazResponse = {};
      })
      .addCase(RazorPayOrderCreate.fulfilled, (state, action) => {
        state.loading = false;
        state.createOrderRazResponse = action.payload.response;
      })
      .addCase(RazorPayOrderCreate.rejected, (state) => {
        state.loading = false;
        state.createOrderRazResponse = {};
      });

    builder
      .addCase(RazorPayVerifyOrderPayment.pending, (state) => {
        state.loading = true;
        state.createOrderRazResponse = {};
      })
      .addCase(RazorPayVerifyOrderPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.createOrderRazResponse = action.payload.response;
      })
      .addCase(RazorPayVerifyOrderPayment.rejected, (state) => {
        state.loading = false;
        state.createOrderRazResponse = {};
      });

    builder
      .addCase(PlaceOrder.pending, (state) => {
        state.orderProcessing = true;
        state.loading = true;
        state.createOrderResponse = {};
      })
      .addCase(PlaceOrder.fulfilled, (state, action) => {
        state.orderProcessing = true;
        state.loading = false;
        state.createOrderResponse = action.payload.response;
      })
      .addCase(PlaceOrder.rejected, (state) => {
        state.orderProcessing = true;
        state.loading = false;
        state.createOrderResponse = {};
      });

    builder
      .addCase(getOrders.pending, (state) => {
        state.orderProcessing = true;
        state.loading = true;
        state.orders = {};
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.orderProcessing = true;
        state.loading = false;
        state.orders = action.payload.response;
      })
      .addCase(getOrders.rejected, (state) => {
        state.orderProcessing = true;
        state.loading = false;
        state.orders = {};
      });

    builder
      .addCase(getSingleOrders.pending, (state) => {
        state.orderProcessing = true;
        state.loading = true;
        state.singleOrders = {};
      })
      .addCase(getSingleOrders.fulfilled, (state, action) => {
        state.orderProcessing = true;
        state.loading = false;
        state.singleOrders = action.payload.response;
      })
      .addCase(getSingleOrders.rejected, (state) => {
        state.orderProcessing = true;
        state.loading = false;
        state.singleOrders = {};
      });
  },
});

export default OrderSlice.reducer;
